import React, { useState } from 'react';
import { db, storage } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import HeaderMenu from '../components/HeaderMenu';
import PageWrapper from '../components/PageWrapper';
import '../styles/CreateJobCard.css';

function CreateJobCard() {
  const [destination, setDestination] = useState('Abu Dhabi');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [age, setAge] = useState('');
  const [audiogram, setAudiogram] = useState({
    Left: { '250': '', '500': '', '1000': '', '2000': '', '3000': '', '4000': '' },
    Right: { '250': '', '500': '', '1000': '', '2000': '', '3000': '', '4000': '' },
  });
  const [hearingModel, setHearingModel] = useState('');
  const [colorSelection, setColorSelection] = useState([]);
  const [shellStyle, setShellStyle] = useState({});
  const [earmoldMaterial, setEarmoldMaterial] = useState({});
  const [earmoldColor, setEarmoldColor] = useState('');
  const [venting, setVenting] = useState({});
  const [finish, setFinish] = useState('');
  const [shellOptions, setShellOptions] = useState({});
  const [wirelessAccessories, setWirelessAccessories] = useState({});
  const [audiologistName, setAudiologistName] = useState('');
  const [technicianName, setTechnicianName] = useState('');
  const [notes, setNotes] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [branch, setBranch] = useState(''); // 👈 New
  const destinations = ['Abu Dhabi', 'Al Ain', 'RAK', 'Al Kuwait Hospital', 'Saqr Hospital', 'Gergash Hospital', 'Tarapichi Hospital'];

  const handleColorToggle = (color) => {
    setColorSelection((prev) => prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]);
  };

  const handleCheckbox = (setter, name) => {
    setter(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSave = async () => {
    try {
      const serial = `SN-${Date.now()}`;
      const fullName = `${firstName} ${lastName}`.toLowerCase();
      const keywords = [firstName.toLowerCase(), lastName.toLowerCase(), fullName, serial.toLowerCase()];

      const uploadedURLs = [];
      if (attachments.length > 0) {
        for (let i = 0; i < attachments.length; i++) {
          const file = attachments[i];
          const fileRef = ref(storage, `attachments/${serial}/${file.name}`);
          await uploadBytes(fileRef, file);
          const url = await getDownloadURL(fileRef);
          uploadedURLs.push(url);
        }
      }

      await addDoc(collection(db, 'jobCards'), {
        destination, firstName, lastName, age, audiogram, hearingModel,
        branch,
        colorSelection, shellStyle, earmoldMaterial, earmoldColor,
        venting, finish, shellOptions, wirelessAccessories,
        audiologistName, technicianName, notes,
        createdAt: Timestamp.now(), status: 'reception', completedAt: null,
        serial, searchKeywords: keywords,
        attachments: uploadedURLs,
      });

      alert('Job Card saved successfully!');
    } catch (error) {
      console.error('❌ Error saving job card:', error);
      alert('Failed to save Job Card.');
    }
  };

  return (
    <PageWrapper>
    <div className="jobcard-container">
        <HeaderMenu />
      <h1 className="jobcard-title">Create Job Card</h1>

<h2 className="jobcard-step">Select Lab Branch</h2>
<select className="jobcard-input" value={branch} onChange={e => setBranch(e.target.value)}>
  <option value="">-- Choose Branch --</option>
  <option value="Dubai Branch">Dubai Branch</option>
  <option value="Abu Dhabi Branch">Abu Dhabi Branch</option>
</select>


      {/* Step 1 */}
      <h2 className="jobcard-step">Step 1: Ship to</h2>
      <select className="jobcard-input" value={destination} onChange={e => setDestination(e.target.value)}>
        {destinations.map(dest => <option key={dest} value={dest}>{dest}</option>)}
      </select>

      {/* Step 2 */}
      <h2 className="jobcard-step">Step 2: Patient Information</h2>
      <div className="jobcard-row">
        <input type="text" className="jobcard-input" placeholder="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} />
        <input type="text" className="jobcard-input" placeholder="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} />
        <input type="text" className="jobcard-input" placeholder="Age" value={age} onChange={e => setAge(e.target.value)} />
      </div>

      {/* Step 3 */}
      <h2 className="jobcard-step">Step 3: Hearing Instrument Selection</h2>
      <input type="text" className="jobcard-input" placeholder="Please type hearing aid model" value={hearingModel} onChange={e => setHearingModel(e.target.value)} />
      <h3 className="jobcard-subtitle">Color</h3>
      <div className="color-options">
        {['Sand (R8)', 'Amber (P2)', 'Espresso (P4)', 'Platinum (P6)', 'Pewter (P7)', 'Charcoal (P8)'].map(color => (
          <label key={color} className="color-checkbox">
            <input type="checkbox" checked={colorSelection.includes(color)} onChange={() => handleColorToggle(color)} /> {color}
          </label>
        ))}
      </div>
      {/* Step 4 */}
      <h2 className="jobcard-step">Step 4: Custom Options</h2>
      <div className="checkbox-group">
        <div className="checkbox-section">
          <label className="checkbox-group-title">Shell Style</label>
          <span className="l-r-label">L  R</span>
          {[
            "Full shell carved (SC)", "Full shell uncarved (SU)", "Half-shell (HC)", "Skeleton (SK)",
            "Semi skeleton (SS)", "Canal lock (CL)", "Canal (CU)", "CROS (CB)",
            "SlimTip, hollow (acrylic)", "SlimTip, soft solid (silicone)"
          ].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setShellStyle, `L-${opt}`)} checked={!!shellStyle[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setShellStyle, `R-${opt}`)} checked={!!shellStyle[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>
        <div className="checkbox-section">
          <label className="checkbox-group-title">Earmold Material</label>
          <span className="l-r-label">L  R</span>
          {["Acrylic (AC)", "Silicone (S70)"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setEarmoldMaterial, `L-${opt}`)} checked={!!earmoldMaterial[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setEarmoldMaterial, `R-${opt}`)} checked={!!earmoldMaterial[`R-${opt}`]} /> {opt}
            </div>
          ))}
          <label className="checkbox-group-title">Earmold Color</label>
          <input type="text" className="jobcard-input" placeholder="Type mold color" value={earmoldColor} onChange={e => setEarmoldColor(e.target.value)} />
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Venting</label>
          <span className="l-r-label">L  R</span>
          {[
            "Small 2.0 mm", "Medium 2.5 mm", "Large 3.0 mm", "No vent (X)", "Parallel (circular) 1.2mm",
            "Styled/Custom (3L)", "IROS A/Semi-Iros/3.0mm", "IROS B/Full-Iros/3.0mm", "Pressure vent 1.2mm"
          ].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setVenting, `L-${opt}`)} checked={!!venting[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setVenting, `R-${opt}`)} checked={!!venting[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Finish</label>
          {['Gloss (HC)', 'No Lacquer (NL)'].map(opt => (
            <label key={opt} className="radio-group">
              <input type="radio" name="finish" value={opt} checked={finish === opt} onChange={e => setFinish(e.target.value)} /> {opt}
            </label>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Shell Options</label>
          <span className="l-r-label">L  R</span>
          {["Removal filament (RF)", "Canal lock (CL)", "Skeleton Lock (SL)"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setShellOptions, `L-${opt}`)} checked={!!shellOptions[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setShellOptions, `R-${opt}`)} checked={!!shellOptions[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Wireless Accessories</label>
          {["Remote Control", "TV Connector", "Partner Mic"].map(opt => (
            <label key={opt} className="checkbox-item">
              <input type="checkbox" onChange={() => handleCheckbox(setWirelessAccessories, opt)} checked={!!wirelessAccessories[opt]} /> {opt}
            </label>
          ))}
        </div>
      </div>
      
      <h2 className="jobcard-step">Step 5: Staff Info & Notes</h2>
      <div className="jobcard-row">
        <input type="text" className="jobcard-input" placeholder="Audiologist Name" value={audiologistName} onChange={e => setAudiologistName(e.target.value)} />
        <input type="text" className="jobcard-input" placeholder="Technician Name" value={technicianName} onChange={e => setTechnicianName(e.target.value)} />
      </div>
      <textarea className="jobcard-notes" placeholder="Enter any important notes here..." value={notes} onChange={e => setNotes(e.target.value)} />

      {/* Step 6 */}
      <h2 className="jobcard-step">Step 6: Attachments</h2>
      <input type="file" multiple onChange={(e) => setAttachments(Array.from(e.target.files))} className="jobcard-input" />
      <p style={{ fontSize: '0.9rem', color: '#555' }}>Files will be uploaded to Firebase Storage.</p>

      <button onClick={handleSave} className="save-btn">Save Job Card</button>
    </div>
    </PageWrapper>
  );
}

export default CreateJobCard;
